import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { importProvidersFrom } from '@angular/core';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { RUNTIME_CONFIG } from './core/config/runtime-config';
import { RuntimeConfigLoader } from './core/config/runtime-config.loader';
import { ApiPrefixInterceptor } from './core/interceptors/api-prefix.interceptor';

const runtimeConfigInitializer = (loader: RuntimeConfigLoader) => () => loader.load();

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    importProvidersFrom(FormsModule, HttpClientModule, MatSnackBarModule),
    {
      provide: APP_INITIALIZER,
      useFactory: runtimeConfigInitializer,
      deps: [RuntimeConfigLoader],
      multi: true
    },
    {
      provide: RUNTIME_CONFIG,
      useFactory: (loader: RuntimeConfigLoader) => loader.get(),
      deps: [RuntimeConfigLoader]
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true
    }
    //provideClientHydration(withEventReplay())
  ]
};
